<template>   
    <div class="cadre-content"> 
        <div v-if="rafraichir">
            document importé avec succès
        </div>        
        <ul class="responsive-table">
            <div class ="cadre-document">
                <div class="scroll-container" >
                    <li class="table-row" v-for="document in listeDocument" :key="document.id">
                        <div class="col col-1" :class="{ 'no-file': !document.fichier, 'has-file': document.fichier }" data-label="Pièce justificative">
                            <i class="far fa-file document-icon" :class="{ 'has-file': document.fichier }"></i>
                            <div class="document-info">
                                <span class="document-name">{{document.lib}}</span>
                            </div>
                        </div>
                        <div class="col col-2" data-label="Fichier">                                   
                            <SimpleUpload :doc="document" :show="true" :isDocCom="isDocCom"/>                                                       
                        </div>
                        
                        <div v-if="!isDocCom" class="col col-3" data-label="Statut"> 
                            <DocumentStatut :documentStatut="document.document_statut" :documentId="document.id"/>                             
                        </div>                        
                    </li>
                </div>
            </div>    
        </ul>
        <!-- <SimpleUpload :folderId="folderId" :show="false" :isUploadClient="false" :isDocCom="isDocCom"/> -->
        <SimpleUpload :folderId="folderId" :show="false" :isUploadClient="true" :isDocCom="isDocCom"/>                                 
    </div>
</template>

<script> 
    import SimpleUpload from '../../components/SimpleUpload.vue'
    import DocumentStatut from '../../components/DocumentStatut.vue'
    export default {
        name: "ListeDocument",
        components: { 
            SimpleUpload,
            DocumentStatut
         },
        props: {
            listeDocument:Array,
            titreFolder:String,
            folderId:Number,
            isDocCom:Boolean
        },
        data(){
            return{
                rafraichir:false
            }
        },
        created(){
            this.$root.$on('afficherDocument',(document) =>{      
                this.rafraichir=true  
                setTimeout(() => {}, "1000")
                this.rafraichir=false    
            })     
        }
     
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/colors";
    
    .cadre-content {
        margin: 10px;
        border-radius: 8px;
        padding: 0 !important;
        margin: 10px;
        overflow: hidden;
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.05);
    }
    
    .scroll-container {
        width: 100%;
        overflow-y: auto;
        scroll-behavior: smooth;
    }
    
    .cadre-document {
        height: 100%;
        border-radius: 0;
        background-color: #FFFFFF;
    }
    
    .fa-folder-open:before {
        content: "\f15b";
    }

    .responsive-table {
        margin: 0;
        padding: 0;
        list-style: none;
        
        li {
            border-radius: 0;
            padding: 16px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            gap: 15px;
            margin: 0;
            border-bottom: 1px solid #F0F0F0;
            transition: background-color 0.15s ease;
            
            &:last-child {
                border-bottom: none;
            }
        }
        
        .table-row {
            background-color: #FFFFFF;
            box-shadow: none;
            border-left: none;
            padding: 14px 16px;
            
            &:hover {
                background-color: #F9F9F9;
            }
        }
        
        .col {
            display: flex;
            align-items: center;
            
            &[data-label]:before {
                display: none;
            }
        }
        
        .col-1 {
            flex: 1;
            min-width: 150px;
            font-weight: 500;
            color: #333;
            display: flex;
            align-items: center;
            gap: 12px;
            white-space: normal;
        }
        
        .col-1.no-file {
            color: #BBB;
        }
        
        .col-1.has-file {
            color: #2196F3;
            font-weight: 600;
        }
        
        .document-info {
            display: flex;
            flex-direction: column;
            gap: 6px;
            min-width: 0;
            flex: 1;
        }
        
        .document-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        
        .document-type-badge {
            display: inline-block;
            padding: 4px 10px;
            background-color: #FFF3E0;
            color: #E67E22;
            border-radius: 4px;
            font-size: 11px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.3px;
            width: fit-content;
        }
        
        .document-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background-color: #F5F5F5;
            border-radius: 6px;
            color: #999;
            font-size: 14px;
            flex-shrink: 0;
            transition: all 0.2s ease;
        }
        
        .document-icon.has-file {
            background-color: #E3F2FD;
            color: #2196F3;
        }
        
        .col-2 {
            flex: 0 0 auto;
            display: flex;
            gap: 8px;
            justify-content: center;
        }
        
        .col-3 {
            flex: 0 0 auto;
            justify-content: flex-end;
        }
    }
    
    /* Responsive adjustments */
    @media only screen and (max-width: 768px) {
        .cadre-content {
            padding: 0;
            border-radius: 6px;
        }
        
        .responsive-table li {
            flex-direction: column;
            align-items: flex-start;
            padding: 14px;
            gap: 12px;
        }
        
        .col {
            width: 100%;
            flex-direction: column !important;
            align-items: flex-start !important;
        }
        
        .col:before {
            content: attr(data-label);
            font-weight: 600;
            color: #666;
            font-size: 11px;
            text-transform: uppercase;
            margin-bottom: 6px;
            display: block !important;
        }
        
        .col-1 {
            min-width: unset;
            white-space: normal;
        }
        
        .col-2, .col-3 {
            justify-content: flex-start !important;
        }
        
        .col-2 {
            display: flex;
            gap: 6px;
            flex-wrap: wrap;
        }
    }
    
</style>